module.exports = __webpack_public_path__ + "static/media/insurance.d3a9c151.jpg";